import { DEFAULT_USE_CASE_HEADER_VALUE, USE_CASE_HEADER_KEY } from "./request/meta";
var BaseClient = /** @class */ (function () {
    function BaseClient(apiToken, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.useCaseHeader, useCaseHeader = _c === void 0 ? DEFAULT_USE_CASE_HEADER_VALUE : _c;
        this.useCaseHeader = useCaseHeader;
        this.apiToken = apiToken;
    }
    BaseClient.prototype.preFlightProcessOptions = function (options) {
        if (options.headers === undefined) {
            options.headers = {};
        }
        options.headers['Authorization'] = "Bearer ".concat(this.apiToken);
        options.headers[USE_CASE_HEADER_KEY] = this.useCaseHeader;
    };
    return BaseClient;
}());
export default BaseClient;
